// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"22":"9095698f","726":"d0dcb9db","985":"d84ddc72"}[chunkId] + ".css";
};